import QuestionTypeSmokingFrequency from ".";

export default function QuestionTypeSmokingFrequencyExamples() {
  const onChange = (value: any) => {
    console.log("onChange()", value);
  };

  return (
    <>
      <QuestionTypeSmokingFrequency onChange={onChange} />
    </>
  );
}
